module.exports = __webpack_public_path__ + "img/brand-06.81717280.png";